import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-footer"},[_c('div',{staticClass:"footer-actions"},[_c(VBtn,{staticClass:"btn-cancel",attrs:{"outlined":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(" Cancel ")]),_c(VBtn,{staticClass:"btn-save",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v(" Save Changes "),_c(VIcon,{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("fa-regular fa-check")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }